// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__REZVE","choiceBoxes":"toolbarselects_choiceBoxes__2hvx9","simpleField":"toolbarselects_simpleField__1Idu7"};